import React, { useEffect, useState }  from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NoteGroupAdd = ({ createNoteGroup, weddingId, note, groupId, index, notesEdit, addMode, setAddMode }) => {

  const [groupAddMode, setGroupAddMode] = useState(-1);

  useEffect(() => {
    if (addMode) {
      addGroup();
    }
  }, [addMode]);

  const addGroup = () => {
    setGroupAddMode(index);
  };

  const createNewGroup = (e) => {
    createNoteGroup({
      weddingId,
      groupName: e.target.value.trim() || 'Add Section Title',
      lastNoteOrder: note?.order || 0,
      groupId: groupId || 0,
    });
    setGroupAddMode(-1);
    if (addMode) {
      setAddMode(false);
    }
  };

  return (
    <>
      {groupAddMode === index ? (
        <div className="note-group__head add-mode">
          <div className="note-group__center">
            <input
              className="note-group__input"
              placeholder="Add Section Title"
              onBlur={(e) => createNewGroup(e)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  createNewGroup(e);
                }
              }}
              autoFocus
            />
          </div>
        </div>
      ) : (
        <div
          className="note-group-add"
          onClick={addGroup}
        >
          <div className="note-group-add__head">
            {notesEdit ? (
              <>
                <i className="note-group-add__icon">
                  <FontAwesomeIcon icon={['fal', 'plus-circle']} />
                </i>
                <hr className="note-group-add__hr" />
              </>
              ) : null
            }
          </div>
        </div>
      )}
    </>
  );
};

export default NoteGroupAdd;
